import ScheduledInterviews from "../../Components/ScheduledInterviews";
import StatsList from "./StatsList";
import useApplicationLimit from "./useApplicationLimit";
import CareersSection from "./CareersSection";
import "./index.scss";

const Home = () => {
  useApplicationLimit();

  return (
    <section className="dashboard-page hide-scroll-bar">
      <StatsList />
      <CareersSection />
      <ScheduledInterviews />
    </section>
  );
};

export default Home;
